import * as React from 'react';
import SecurityIcon from '@material-ui/icons/Security';
import { TK } from '../store/translations/translationKeys';
import { Consents } from '../models';

export const CONSENT_LABEL_MAP: Record<keyof Consents, TK> = {
    gdpr: TK.consentGDPR,
    healthDataProcessing: TK.consentHealthDataProcessing,
    emailMarketing: TK.consentEmailMarketing,
    smsMarketing: TK.consentSMSMarketing,
    birthdayMessage: TK.consentBirthdayMessage,
    emailReminders: TK.consentEmailReminders,
    smsReminders: TK.consentSMSReminders,
    whatsAppReminders: TK.consentWhatsAppReminders,
    dataSharingWithProfessionals: TK.consentDataSharingWithProfessionals,
    thirdPartyDataSharing: TK.consentThirdPartyDataSharing,
    imageOrVideoCaptureForInstitutionalPurposes: TK.consentImageOrVideoCaptureForInstitutionalPurposes
};

export const isLegacyConsentGroupName = (name: string): boolean => /^Consent(?:\s+\d+)?$/i.test(name.trim());

export const getConsentGroupName = (name: string, t: (key: TK) => string): string => {
    return isLegacyConsentGroupName(name) ? t(TK.consentDefaultName) : name;
};

export const getConsentLabel = (consentKey: keyof Consents, t: (key: TK) => string): string => {
    return t(CONSENT_LABEL_MAP[consentKey]);
};

export const getConsentShortLabel = (consentKey: keyof Consents, t: (key: TK) => string): JSX.Element => {
    return (
        <span style={{display: 'inline-flex', alignItems: 'center', gap: 'var(--spacer-XXS)'}}>
            <SecurityIcon style={{fontSize: '0.9em'}} />
            {t(CONSENT_LABEL_MAP[consentKey])}
        </span>
    );
};
